<template>
    <b-form-group
            class="c-mask"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <b-form-input
                v-if="required"
                type="text"
                :id="id"
                :state="chkState(id)"
                v-mask="mask"
                v-model="dataValue"
                :placeholder="placeholder"
                :autocomplete="autocomplete"></b-form-input>
        <b-form-input
                v-else
                type="text"
                :id="id"
                v-mask="mask"
                v-model="dataValue"
                :placeholder="placeholder"
                :autocomplete="autocomplete"></b-form-input>
      <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
        {{invalidFeedbackMessage}}
      </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
  import Vue from 'vue'
  import { VueMaskDirective } from 'v-mask'
  Vue.directive('mask', VueMaskDirective);

  export default {
      name: 'InputMask',
      components: {
      },
      props: {
          mask: {
              type: String,
              default: ''
          },
          guide: {
              type: Boolean,
              default: true
          },
          showMask: {
              type: Boolean,
              default: true
          },
          keepCharPositions: {
              type: Boolean,
              default: true
          },
          placeholderChar: {
              type: String,
              default: ''
          },
          required: {
              type: Boolean,
              default: false
          },
          value: {
              type: String,
              default: ''
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          autocomplete: {
              type: String,
              default: ''
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
          }
      },
      mounted() {
          this.dataValue = this.value
      },
      data: () => {
          return {
              dataValue: ''
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>